import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import FormVista from '../components/form/FormVista';
import '../components/form/FormVista.css';

// Pagina pubblica di un form (/f/<slug>): nessun login, nessun token inviato.
const BASE = process.env.REACT_APP_API_URL || '/api';
const pubblico = axios.create({ baseURL: BASE });

export default function FormPubblico() {
  const { slug } = useParams();
  const [form, setForm] = useState(null);
  const [errore, setErrore] = useState('');

  useEffect(() => {
    pubblico.get(`/form-pubblico/${encodeURIComponent(slug)}`)
      .then(r => {
        setForm(r.data); document.title = r.data.titolo;
        // aperto da un indirizzo vecchio (il form ha cambiato link): nella barra si vede quello nuovo
        if (r.data.slug && r.data.slug !== slug) window.history.replaceState(null, '', `/f/${r.data.slug}`);
      })
      .catch(e => setErrore(e.response?.status === 404 ? 'Questo modulo non esiste o non è più disponibile.' : (e.response?.data?.error || 'Impossibile caricare il modulo.')));
  }, [slug]);

  const invia = async (dati) => (await pubblico.post(`/form-pubblico/${encodeURIComponent(slug)}`, dati)).data;

  if (!form) return (
    <div className="fv" style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24 }}>
      <div style={{ textAlign: 'center', color: 'var(--sub)' }}>
        <img src="/logo.png" alt="B-Cheers" style={{ height: 56, marginBottom: 14, opacity: errore ? 1 : 0.6 }} />
        <div style={{ fontWeight: 600 }}>{errore || 'Caricamento…'}</div>
      </div>
    </div>
  );

  const a = form.aspetto || {};
  const immagine = (tipo) => a[`${tipo}_img`] ? `${BASE}/form-pubblico/${encodeURIComponent(slug)}/immagine/${tipo}?v=${encodeURIComponent(a[`${tipo}_img`])}` : null;
  const fotoOpzione = (nome) => `${BASE}/form-pubblico/${encodeURIComponent(slug)}/foto-opzione/${encodeURIComponent(nome)}`;
  return (
    <div style={{ minHeight: '100vh', background: '#F2F2F5' }}>
      <FormVista form={form} url={{ copertina: immagine('copertina'), sfondo: immagine('sfondo'), foto: fotoOpzione }} onInvia={invia} />
    </div>
  );
}
